import React from "react";

const AboutLegacy = ({ legacy }) => {
  if (!legacy) return null;

  const points = Array.isArray(legacy.points) ? legacy.points : [];

  return (
    <section className="bg-white py-8 md:py-10 lg:py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="mx-auto max-w-7xl text-center">
          <h2 className="text-3xl font-bold text-brand-purple md:text-4xl lg:text-[2.5rem]">
            {legacy.title}
          </h2>
          {legacy.description ? (
            <p className="mt-6 text-[14px] leading-[1.85] text-[#555555] md:text-[15px]">
              {legacy.description}
            </p>
          ) : null}
        </div>

        {legacy.image ? (
          <div className="mt-12 md:mt-14">
            <article className="overflow-hidden">
              <img
                src={legacy.image}
                alt={legacy.title}
                referrerPolicy="no-referrer"
                className="h-auto w-full object-cover"
              />
            </article>
          </div>
        ) : null}

        {points.length > 0 ? (
          <div className="mt-14 grid grid-cols-1 gap-10 md:mt-16 lg:grid-cols-2 lg:gap-14">
            {points.map((point) => (
              <div key={point.id}>
                <h3 className="text-[22px] font-bold text-brand-purple md:text-[24px]">
                  {point.title}
                </h3>
                {point.description ? (
                  <p className="mt-4 text-[14px] leading-[1.85] text-[#555555] md:text-[15px]">
                    {point.description}
                  </p>
                ) : null}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default AboutLegacy;
